import React from 'react';

import './FundListActionBarLink.scss';

const FundListActionBarLink = ({ isSalesforceRep, customerWebViewEnabled }) => {
  return (
    <>
      {!customerWebViewEnabled && isSalesforceRep ? (
        <span>Add new funds to the existing mutual fund accounts…</span>
      ) : (
        <span>
          <span className="fund-list-action-bar-link-call-to-action">
            Looking to expand your portfolio?
          </span>{' '}
          Add new funds to your existing mutual fund accounts…
        </span>
      )}
    </>
  );
};

export default FundListActionBarLink;
